<template>
    <component :is="layout">
        <slot></slot>
    </component>
</template>

<script setup>
import {useStore} from "vuex";
import {computed, onMounted } from "vue";

const store = useStore()

const user = computed(() => store.getters.user)

const layout = computed(() => {
    if(user.value) {
        return 'inner-layout'
    }
    return 'default'
})
</script>

<style scoped>

</style>
